import { useEffect, useState } from "react";
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from "../ui/table";
import { Badge } from "../ui/badge";
import { Button } from "../ui/button";
import { api } from "../../lib/api";
import { ADMIN } from "../../constants/testIds";
import { ReleaseEditorModal } from "./ReleaseEditorModal";
import { toast } from "../ui/sonner";

const STATUS_VARIANT = { active: "default", draft: "secondary", archived: "outline" };

export const ReleaseManagement = ({ releases, onChanged }) => {
  const [editing, setEditing] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const openCreate = () => { setEditing(null); setModalOpen(true); };
  const openEdit = (r) => { setEditing(r); setModalOpen(true); };

  const onDelete = async (r) => {
    if (!window.confirm(`Delete release "${r.title}"? This cannot be undone.`)) return;
    try {
      await api.delete(`/admin/releases/${r.id}`);
      toast.success("Release deleted");
      onChanged();
    } catch (e) {
      toast.error("Failed to delete release");
    }
  };

  return (
    <div className="p-5 sm:p-6 rounded-xl border border-slate-800 bg-slate-900/80 backdrop-blur-md min-w-0">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-slate-200" style={{ fontFamily: "'Outfit', sans-serif" }}>Releases</h3>
        <Button data-testid={ADMIN.addReleaseButton} onClick={openCreate} className="rounded-full bg-amber-500 hover:bg-amber-400 text-slate-950 transition-colors duration-300">
          + New Release
        </Button>
      </div>
      <Table data-testid={ADMIN.releaseTable}>
        <TableHeader>
          <TableRow className="border-white/10">
            <TableHead className="text-slate-400">Title</TableHead>
            <TableHead className="text-slate-400">Slug</TableHead>
            <TableHead className="text-slate-400">Status</TableHead>
            <TableHead className="text-slate-400">Sleep Controls</TableHead>
            <TableHead className="text-slate-400 text-right">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {releases.map((r) => (
            <TableRow key={r.id} className="border-white/5">
              <TableCell className="text-slate-200">{r.title}</TableCell>
              <TableCell className="text-slate-400 font-mono text-xs">{r.slug}</TableCell>
              <TableCell><Badge variant={STATUS_VARIANT[r.status] || "outline"}>{r.status}</Badge></TableCell>
              <TableCell className="text-slate-400">{r.featureFlags?.sleepControls ? "On" : "Off"}</TableCell>
              <TableCell className="text-right space-x-2">
                <Button data-testid={`${ADMIN.editReleaseButtonPrefix}-${r.slug}`} size="sm" variant="outline" className="border-white/10 text-slate-300" onClick={() => openEdit(r)}>Edit</Button>
                <Button data-testid={`${ADMIN.deleteReleaseButtonPrefix}-${r.slug}`} size="sm" variant="destructive" onClick={() => onDelete(r)}>Delete</Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {modalOpen && (
        <ReleaseEditorModal
          release={editing}
          onClose={() => setModalOpen(false)}
          onSaved={() => { setModalOpen(false); onChanged(); }}
        />
      )}
    </div>
  );
};
